module.exports = __webpack_public_path__ + "img/05郑威.760f0445.jpg";